import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { SectionReveal } from '../components/SectionReveal';
import { TestimonialCard } from '../components/TestimonialCard';
import { CheckCircle2Icon, SparklesIcon, TargetIcon, PaletteIcon, ShieldCheckIcon, LayersIcon, RocketIcon } from 'lucide-react';
import { FaqSection } from '../components/FaqSection';
export function CosmeticEmpire() {
  return <div className="min-h-screen bg-cream" data-id="element-112">
      <HeroSection tagline="✨ LIBERTY — THE COSMETIC BRAND CREATION PROGRAM" title="Crée ta marque de cosmétiques. Et deviens une marque." subtitle="Programme privé one-to-one sur 10 mois. Un accompagnement humain personnalisé pour transformer ton idée en véritable marque cosmétique structurée, positionnée et prête à conquérir le marché." ctaText="Candidater · Réserver un appel privé" ctaLink="https://calendly.com/sarahmarte/cosmetic-empire" theme="blush" backgroundImage="https://cdn.magicpatterns.com/uploads/jXR8kFcsGYkhK1TGRp3Yje/543aa613-79d1-4622-9843-3adcb1cb4fa4.jpg" data-id="element-113" />

      {/* Badges Floating */}
      <div className="flex justify-center gap-3 mt-8 md:-mt-6 relative z-30 px-4 flex-wrap" data-id="element-114">
        <span className="bg-white text-navy px-6 py-2 rounded-full text-sm font-medium shadow-md border border-blush flex items-center gap-2" data-id="element-115">
          <span className="w-2 h-2 rounded-full bg-rosegold" data-id="element-116"></span> 10 mois —
          One-to-One
        </span>
        <span className="bg-white text-navy px-6 py-2 rounded-full text-sm font-medium shadow-md border border-blush flex items-center gap-2" data-id="element-117">
          <span className="w-2 h-2 rounded-full bg-rosegold" data-id="element-118"></span> Aucun
          contenu vidéo · 100% humain
        </span>
      </div>

      {/* Pricing Highlight Card */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto relative z-20" data-id="element-119">
        <SectionReveal data-id="element-120">
          <div className="bg-blush rounded-3xl p-8 md:p-12 shadow-xl shadow-pink-100/50 text-center border border-white relative overflow-hidden" data-id="element-121">
            <div className="absolute top-0 right-0 w-32 h-32 bg-white rounded-full mix-blend-overlay filter blur-2xl opacity-60" data-id="element-122"></div>

            <span className="inline-block bg-rosegold text-white text-xs font-bold tracking-widest uppercase px-4 py-1 rounded-full mb-6" data-id="element-123">
              Offre spéciale lancement
            </span>

            <div className="flex flex-col items-center justify-center mb-6" data-id="element-124">
              <span className="text-navy/50 line-through text-xl font-serif mb-2" data-id="element-125">
                CHF 8'000
              </span>
              <span className="text-5xl md:text-6xl font-serif text-rosegold font-medium" data-id="element-126">
                CHF 3'900
              </span>
            </div>

            <p className="text-xl text-navy font-medium mb-6 flex items-center justify-center gap-2" data-id="element-127">
              🎁 Site e-commerce professionnel offert et inclus
            </p>

            <p className="text-sm text-navy/60 italic" data-id="element-128">
              Investissement minimum recommandé pour le projet : ~5 000€
              (production, branding, lancement)
            </p>
          </div>
        </SectionReveal>
      </section>

      {/* Pourquoi Sarah */}
      <section className="py-20 bg-white" data-id="element-129">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-130">
          <SectionReveal data-id="element-131">
            <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-132">
              <h2 className="text-3xl md:text-4xl font-serif text-navy mb-6" data-id="element-133">
                Pourquoi choisir Sarah pour vous accompagner ?
              </h2>
              <p className="text-navy/70 text-lg leading-relaxed" data-id="element-134">
                Créer une marque ne se résume pas à trouver un laboratoire.
                C'est un écosystème complet qui nécessite une expertise globale.
              </p>
            </div>
          </SectionReveal>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-135">
            <SectionReveal delay={0.1} data-id="element-136">
              <div className="bg-blush-light rounded-3xl p-8 h-full border border-white shadow-sm hover:shadow-md transition-shadow" data-id="element-137">
                <div className="bg-white w-12 h-12 rounded-full flex items-center justify-center mb-6 shadow-sm" data-id="element-138">
                  <TargetIcon className="w-6 h-6 text-rosegold" data-id="element-139" />
                </div>
                <h3 className="text-xl font-serif text-navy mb-3" data-id="element-140">
                  Stratégie Business
                </h3>
                <p className="text-navy/70 text-sm leading-relaxed" data-id="element-141">
                  Au-delà du produit, nous construisons un modèle économique
                  rentable, scalable et pérenne. Positionnement, pricing, et
                  canaux de distribution.
                </p>
              </div>
            </SectionReveal>

            <SectionReveal delay={0.2} data-id="element-142">
              <div className="bg-blush-light rounded-3xl p-8 h-full border border-white shadow-sm hover:shadow-md transition-shadow" data-id="element-143">
                <div className="bg-white w-12 h-12 rounded-full flex items-center justify-center mb-6 shadow-sm" data-id="element-144">
                  <ShieldCheckIcon className="w-6 h-6 text-rosegold" data-id="element-145" />
                </div>
                <h3 className="text-xl font-serif text-navy mb-3" data-id="element-146">
                  Normes EU & Conformité
                </h3>
                <p className="text-navy/70 text-sm leading-relaxed" data-id="element-147">
                  DIP, CPNP, allégations... La réglementation cosmétique est
                  stricte. Nous vous guidons pour que votre marque soit 100%
                  conforme et sécurisée.
                </p>
              </div>
            </SectionReveal>

            <SectionReveal delay={0.3} data-id="element-148">
              <div className="bg-blush-light rounded-3xl p-8 h-full border border-white shadow-sm hover:shadow-md transition-shadow" data-id="element-149">
                <div className="bg-white w-12 h-12 rounded-full flex items-center justify-center mb-6 shadow-sm" data-id="element-150">
                  <LayersIcon className="w-6 h-6 text-rosegold" data-id="element-151" />
                </div>
                <h3 className="text-xl font-serif text-navy mb-3" data-id="element-152">
                  Accompagnement Fiscal
                </h3>
                <p className="text-navy/70 text-sm leading-relaxed" data-id="element-153">
                  Structuration de société, gestion de la TVA e-commerce,
                  optimisation. Des bases saines pour éviter les erreurs
                  coûteuses au lancement.
                </p>
              </div>
            </SectionReveal>

            <SectionReveal delay={0.4} data-id="element-154">
              <div className="bg-blush-light rounded-3xl p-8 h-full border border-white shadow-sm hover:shadow-md transition-shadow" data-id="element-155">
                <div className="bg-white w-12 h-12 rounded-full flex items-center justify-center mb-6 shadow-sm" data-id="element-156">
                  <SparklesIcon className="w-6 h-6 text-rosegold" data-id="element-157" />
                </div>
                <h3 className="text-xl font-serif text-navy mb-3" data-id="element-158">
                  Coaching Mindset
                </h3>
                <p className="text-navy/70 text-sm leading-relaxed" data-id="element-159">
                  L'entrepreneuriat est un marathon mental. Un soutien
                  psychologique pour dépasser vos peurs, assumer votre ambition
                  et devenir une vraie CEO.
                </p>
              </div>
            </SectionReveal>
          </div>
        </div>
      </section>

      {/* Actif, pas un projet */}
      <section className="py-20 bg-cream" data-id="element-160">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-161">
          <SectionReveal data-id="element-162">
            <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-163">
              <h2 className="text-3xl md:text-4xl font-serif text-navy mb-6" data-id="element-164">
                Une marque cosmétique est un{' '}
                <span className="italic text-rosegold" data-id="element-165">actif</span>, pas un
                projet
              </h2>
              <p className="text-navy/70 text-lg leading-relaxed" data-id="element-166">
                Dans l'industrie beauté, les marques qui réussissent ne sont pas
                celles qui improvisent. Ce sont celles qui sont construites avec
                une vision claire, une stratégie précise et une exécution
                maîtrisée.
              </p>
            </div>
          </SectionReveal>

          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6" data-id="element-167">
            {[{
            icon: <TargetIcon className="w-6 h-6 text-rosegold" data-id="element-168" />,
            text: 'Un positionnement de marque fort et différenciant'
          }, {
            icon: <PaletteIcon className="w-6 h-6 text-rosegold" data-id="element-169" />,
            text: 'Une identité visuelle et narrative premium'
          }, {
            icon: <ShieldCheckIcon className="w-6 h-6 text-rosegold" data-id="element-170" />,
            text: 'Des produits conformes aux normes (DIP, CPNP)'
          }, {
            icon: <LayersIcon className="w-6 h-6 text-rosegold" data-id="element-171" />,
            text: 'Une architecture produit cohérente'
          }, {
            icon: <RocketIcon className="w-6 h-6 text-rosegold" data-id="element-172" />,
            text: "Une stratégie de lancement et d'acquisition"
          }].map((item, idx) => <SectionReveal key={idx} delay={idx * 0.1} data-id="element-173">
                <div className="bg-blush-light rounded-3xl p-6 h-full flex flex-col items-center text-center border border-white shadow-sm hover:shadow-md transition-shadow" data-id="element-174">
                  <div className="bg-white p-3 rounded-full mb-4 shadow-sm" data-id="element-175">
                    {item.icon}
                  </div>
                  <p className="text-navy/80 text-sm font-medium" data-id="element-176">
                    {item.text}
                  </p>
                </div>
              </SectionReveal>)}
          </div>
        </div>
      </section>

      {/* 2 Phases */}
      <section className="py-24 bg-cream relative overflow-hidden" data-id="element-177">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-178">
          <div className="absolute top-20 -left-20 w-96 h-96 bg-blush rounded-full mix-blend-multiply filter blur-3xl opacity-40" data-id="element-179"></div>
          <div className="absolute bottom-20 -right-20 w-96 h-96 bg-peach-light rounded-full mix-blend-multiply filter blur-3xl opacity-40" data-id="element-180"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-181">
          <SectionReveal data-id="element-182">
            <div className="text-center mb-16" data-id="element-183">
              <h2 className="text-3xl md:text-4xl font-serif text-navy mb-4" data-id="element-184">
                Un accompagnement structuré en 2 phases
              </h2>
            </div>
          </SectionReveal>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-185">
            {/* Phase 1 */}
            <SectionReveal delay={0.1} data-id="element-186">
              <div className="bg-white rounded-3xl p-8 md:p-10 shadow-xl shadow-pink-100/40 border border-blush h-full flex flex-col" data-id="element-187">
                <span className="text-rosegold font-bold tracking-widest uppercase text-sm mb-2 block" data-id="element-188">
                  Phase 1 (3 mois)
                </span>
                <h3 className="text-2xl font-serif text-navy mb-3" data-id="element-189">
                  Brand Creation Intensive
                </h3>
                <p className="text-navy/60 mb-8 pb-6 border-b border-blush" data-id="element-190">
                  Une phase immersive dédiée à la création complète de ta
                  marque.
                </p>

                <ul className="space-y-4 mb-8 flex-grow" data-id="element-191">
                  {['Définition du positionnement et de la stratégie', "Création de l'identité de marque (nom, univers, storytelling)", 'Sélection des produits et du laboratoire', 'Structuration du développement produit', 'Accompagnement sur la mise en conformité (DIP avec partenaires spécialisés)', "Préparation du packaging et de l'univers visuel", 'Construction de la fondation complète de la marque'].map((item, i) => <li key={i} className="flex items-start gap-3 text-navy/80 text-sm" data-id="element-192">
                      <SparklesIcon className="w-5 h-5 text-rosegold flex-shrink-0 mt-0.5" data-id="element-193" />
                      <span data-id="element-194">{item}</span>
                    </li>)}
                </ul>

                <div className="bg-blush-light rounded-2xl p-4 text-center" data-id="element-195">
                  <p className="text-rosegold font-medium text-sm" data-id="element-196">
                    🎯 Créer une marque solide, prête à entrer sur le marché
                  </p>
                </div>
              </div>
            </SectionReveal>

            {/* Phase 2 */}
            <SectionReveal delay={0.2} data-id="element-197">
              <div className="bg-white rounded-3xl p-8 md:p-10 shadow-xl shadow-pink-100/40 border border-blush h-full flex flex-col" data-id="element-198">
                <span className="text-rosegold font-bold tracking-widest uppercase text-sm mb-2 block" data-id="element-199">
                  Phase 2 (7 mois)
                </span>
                <h3 className="text-2xl font-serif text-navy mb-3" data-id="element-200">
                  Launch & Scale
                </h3>
                <p className="text-navy/60 mb-8 pb-6 border-b border-blush" data-id="element-201">
                  Une phase stratégique dédiée au lancement et à la croissance.
                </p>

                <ul className="space-y-4 mb-8 flex-grow" data-id="element-202">
                  {['Création de ton site e-commerce (inclus et offert dans LIBERTY)', 'Mise en place de la stratégie marketing globale', 'Direction créative du contenu et de la marque', 'Lancement officiel de la marque', 'Mise en place des publicités (ads) et acquisition clients', 'Optimisation des ventes et du positionnement', 'Accompagnement stratégique continu'].map((item, i) => <li key={i} className="flex items-start gap-3 text-navy/80 text-sm" data-id="element-203">
                      <SparklesIcon className="w-5 h-5 text-rosegold flex-shrink-0 mt-0.5" data-id="element-204" />
                      <span data-id="element-205">{item}</span>
                    </li>)}
                </ul>

                <div className="bg-blush-light rounded-2xl p-4 text-center" data-id="element-206">
                  <p className="text-rosegold font-medium text-sm" data-id="element-207">
                    🎯 Transformer ta marque en business actif et scalable
                  </p>
                </div>
              </div>
            </SectionReveal>
          </div>
        </div>
      </section>

      {/* Checklist & Structure */}
      <section className="py-24 bg-white" data-id="element-208">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-209">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-210">
            <SectionReveal data-id="element-211">
              <h2 className="text-3xl font-serif text-navy mb-8" data-id="element-212">
                Ce que tu construis avec LIBERTY
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-213">
                {['Une marque complète et structurée', 'Une identité premium et cohérente', 'Un positionnement différenciant', 'Des produits conformes aux normes', 'Un laboratoire sélectionné', 'Un packaging prêt pour production', 'Un site e-commerce offert', 'Une stratégie marketing complète', 'Une structure business prête à lancer'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-214">
                    <CheckCircle2Icon className="w-5 h-5 text-rosegold flex-shrink-0" data-id="element-215" />
                    <span className="text-navy/80 text-sm" data-id="element-216">{item}</span>
                  </div>)}
              </div>
            </SectionReveal>

            <SectionReveal delay={0.2} data-id="element-217">
              <h2 className="text-3xl font-serif text-navy mb-8" data-id="element-218">
                Structure business & vision internationale
              </h2>
              <div className="bg-blush-light rounded-3xl p-8 border border-white shadow-sm" data-id="element-219">
                <p className="text-navy/80 leading-relaxed" data-id="element-220">
                  LIBERTY inclut également l'accompagnement sur les bases
                  essentielles d'une marque e-commerce : organisation de la
                  chaîne logistique (production, stockage, expédition), mise en
                  relation avec des partenaires spécialisés, compréhension des
                  bases fiscales liées à la vente en ligne (TVA selon marchés),
                  et la structuration globale d'un modèle de marque scalable et
                  international.
                </p>
              </div>
            </SectionReveal>
          </div>
        </div>
      </section>

      {/* Pour toi / Pas pour toi */}
      <section className="py-20 bg-sand/30" data-id="element-221">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-222">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-223">
            <SectionReveal data-id="element-224">
              <div className="bg-white rounded-3xl p-8 shadow-md border-t-4 border-rosegold h-full" data-id="element-225">
                <h3 className="text-xl font-serif text-navy mb-6 flex items-center gap-2" data-id="element-226">
                  <span className="text-2xl" data-id="element-227">✅</span> LIBERTY est pour toi si :
                </h3>
                <ul className="space-y-4" data-id="element-228">
                  {['Tu veux créer une vraie marque', 'Tu veux un accompagnement premium et structuré', 'Tu as une vision sérieuse et long terme', 'Tu es prête à construire un vrai business', "Tu veux éviter les erreurs et aller à l'essentiel"].map((item, i) => <li key={i} className="flex items-start gap-2 text-navy/80 text-sm" data-id="element-229">
                      <span className="text-rosegold mt-0.5" data-id="element-230">•</span> {item}
                    </li>)}
                </ul>
              </div>
            </SectionReveal>

            <SectionReveal delay={0.2} data-id="element-231">
              <div className="bg-white rounded-3xl p-8 shadow-md border-t-4 border-navy/20 h-full" data-id="element-232">
                <h3 className="text-xl font-serif text-navy mb-6 flex items-center gap-2" data-id="element-233">
                  <span className="text-2xl" data-id="element-234">❌</span> Pas pour toi si :
                </h3>
                <ul className="space-y-4" data-id="element-235">
                  {['Tu veux juste tester une idée', "Tu n'es pas prête à investir", 'Tu cherches des résultats sans engagement', 'Tu veux une solution rapide sans stratégie'].map((item, i) => <li key={i} className="flex items-start gap-2 text-navy/80 text-sm" data-id="element-236">
                      <span className="text-navy/40 mt-0.5" data-id="element-237">•</span> {item}
                    </li>)}
                </ul>
              </div>
            </SectionReveal>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-24 bg-white" data-id="element-238">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-239">
          <SectionReveal data-id="element-240">
            <div className="text-center mb-16" data-id="element-241">
              <h2 className="text-3xl md:text-4xl font-serif text-navy mb-4" data-id="element-242">
                Elles ont bâti leur empire
              </h2>
              <p className="text-navy/70 max-w-2xl mx-auto" data-id="element-243">
                Des femmes qui ont choisi de transformer leur idée en véritable
                marque avec LIBERTY.
              </p>
            </div>
          </SectionReveal>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-244">
            <TestimonialCard name="Camille Lefèvre" location="Paris, France" photo="https://cdn.magicpatterns.com/uploads/31Rcc42iUEN5M5TPqembfc/Gemini_Generated_Image_avp9ijavp9ijavp9.png" quote="Avant LIBERTY, j'avais une idée. Aujourd'hui, j'ai une vraie marque que je suis fière de porter. Sarah a transformé mon projet flou en un business solide. La conformité, le laboratoire, le site... tout était géré." result="Lancement réussi · 12K€ de CA premier mois" delay={0.1} data-id="element-245" />
            <TestimonialCard name="Inès Bouzidi" location="Casablanca, Maroc" photo="https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=400&auto=format&fit=crop&crop=faces" quote="Ce que j'ai aimé chez Sarah, c'est qu'elle ne vend pas du rêve. Elle structure, elle exige, elle accompagne vraiment. Mon site Shopify était prêt avant même mon premier batch produit. Inestimable." result="Marque lancée en 8 mois · 250+ clientes fidèles" delay={0.2} data-id="element-246" />
            <TestimonialCard name="Léa Marchand" location="Lyon, France" photo="https://cdn.magicpatterns.com/uploads/3wqWBJDULBEEKkdHwbrBuD/Gemini_Generated_Image_tliphntliphntlip.png" quote="J'étais salariée, démotivée, avec une idée de marque dans la tête depuis 3 ans. Sarah m'a fait passer à l'action avec une méthode claire. Aujourd'hui, je vis de ma marque." result="Quittée son CDI · 6K€/mois de revenus marque" delay={0.3} data-id="element-247" />
          </div>
        </div>
      </section>

      {/* FAQ */}
      <FaqSection subtitle="Tout ce que tu dois savoir avant de candidater au programme LIBERTY." items={[{
      question: 'Combien de temps dure le programme LIBERTY ?',
      answer: "Le programme s'étend sur 10 mois en accompagnement privé one-to-one : 3 mois de Brand Creation Intensive pour structurer ta marque, suivis de 7 mois de Launch & Scale pour lancer et faire croître ton business."
    }, {
      question: 'Quel investissement total dois-je prévoir au-delà du programme ?',
      answer: "Au-delà des CHF 3'900 du programme, prévois un investissement minimum d'environ 5 000€ pour le développement de tes produits, la production initiale, le branding (visuels, packaging) et le lancement marketing. C'est l'investissement minimum pour lancer une vraie marque cosmétique."
    }, {
      question: 'Le site e-commerce est-il vraiment offert ?',
      answer: "Oui, totalement. Ton site Shopify professionnel est intégralement créé, configuré et offert dans le cadre du programme. Tu n'as aucune compétence technique à acquérir : tu te concentres uniquement sur la stratégie et la vision de ta marque."
    }, {
      question: "Je n'ai aucune expérience dans la cosmétique, est-ce que c'est pour moi ?",
      answer: "Absolument. LIBERTY est conçu pour les femmes qui partent de zéro mais avec une vision sérieuse. Sarah t'accompagne pas à pas : sélection du laboratoire, formulation, conformité européenne (DIP, CPNP), packaging, marketing... Tu n'as pas besoin d'expertise préalable, juste de l'engagement."
    }, {
      question: 'Comment se passe la mise en conformité (DIP, CPNP) ?',
      answer: "La conformité européenne est l'un des points les plus complexes pour une marque cosmétique. Nous travaillons avec des partenaires spécialisés qui prennent en charge l'élaboration des Dossiers d'Information Produit (DIP) et l'enregistrement CPNP. Tu es accompagnée à chaque étape pour que ta marque soit 100% en règle avant son lancement."
    }, {
      question: "Est-ce que je peux suivre le programme depuis l'étranger ?",
      answer: 'Oui. Le programme est 100% à distance avec des sessions privées en visio. Que tu sois en France, en Suisse, au Maroc ou ailleurs, tu peux suivre LIBERTY sans contrainte géographique.'
    }, {
      question: 'Quelle est la prochaine étape pour rejoindre LIBERTY ?',
      answer: "La première étape est de candidater via un appel privé avec Sarah (gratuit). Cet appel permet de valider que ton projet correspond à l'esprit du programme et que LIBERTY est le bon accompagnement pour toi. Les places sont volontairement limitées pour garantir l'excellence du suivi."
    }]} data-id="element-248" />

      {/* Final CTA */}
      <section className="py-24 bg-blush-light text-center px-4 relative overflow-hidden" data-id="element-249">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-white rounded-full mix-blend-overlay filter blur-3xl opacity-50 pointer-events-none" data-id="element-250"></div>
        <SectionReveal className="relative z-10" data-id="element-251">
          <h2 className="text-3xl md:text-5xl font-serif text-navy mb-6" data-id="element-252">
            Tu ne repars pas avec une idée.
            <br data-id="element-253" />
            <span className="italic text-rosegold" data-id="element-254">
              Tu repars avec une marque.
            </span>
          </h2>
          <p className="text-navy/70 max-w-2xl mx-auto mb-10 text-lg" data-id="element-255">
            Les places pour l'accompagnement One-to-One sont extrêmement
            limitées pour garantir l'excellence du suivi.
          </p>
          <a href="https://calendly.com/sarahmarte/cosmetic-empire" target="_blank" rel="noopener noreferrer" className="inline-block bg-rosegold text-white px-10 py-4 rounded-full font-medium shadow-xl shadow-rosegold/30 hover:bg-rosegold-dark hover:-translate-y-1 transition-all" data-id="element-256">
            Candidater · Réserver mon appel privé
          </a>
        </SectionReveal>
      </section>
    </div>;
}